import axios from 'axios';

import { ApiErrorDto } from 'utils/api/dto';

/** MultipleAccountsForEmailException.CODE: several accounts share the email, the login is needed */
export const LOGIN_REQUIRED_CODE = 'LOGIN_REQUIRED';

const HTTP_FORBIDDEN = 403;
const HTTP_CONFLICT = 409;

const responseOf = (error: unknown) => (axios.isAxiosError(error) ? error.response : undefined);

/** The HTTP status of a failed request; undefined when there was no answer (offline, timeout) */
export const getErrorStatus = (error: unknown): number | undefined => responseOf(error)?.status;

/**
 * POST /public/users/reset-password answers 409 with data.code LOGIN_REQUIRED when several accounts have the email
 * (ExceptionsHandler.processMultipleAccountsForEmail); any other 409 is an ordinary error.
 */
export const isLoginRequiredError = (error: unknown): boolean => {
    const response = responseOf(error);
    const body = response?.data as ApiErrorDto<{ code?: string }> | undefined;

    return response?.status === HTTP_CONFLICT && body?.data?.code === LOGIN_REQUIRED_CODE;
};

/**
 * The message under the login form: 403 is a disabled or locked account (RestAuthenticationFailureHandler),
 * anything else is a wrong login or password.
 */
export const getLoginErrorMessageId = (error: unknown): string =>
    getErrorStatus(error) === HTTP_FORBIDDEN ? 'login.accountLocked' : 'login.error';
